module.exports = __webpack_public_path__ + "static/media/help_and_support.9b864c21.svg";